// extracted by mini-css-extract-plugin
export default {"starWrapper":"Star_starWrapper__IwQZw","star":"Star_star__d76Wi","star1":"Star_star1__ImG6x","star2":"Star_star2__7Ijbe"};